import React from 'react';

const Wyoming = () => {
  return (
    <div>
      
    </div>
  );
}

export default Wyoming;
